import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class Home extends Component {
  render() {
    const LayoutWrapper = this.props.layout

    return (
      <LayoutWrapper>
        <div className="page">
          <h2>Welcome to the Wreckfinder web app</h2>
          <p className="lead">
            Use the power of Wreckfinder, the no.1 best selling iPhone, iPad and Android application
            for finding shipwrecks in UK and Irish costal waters, right here in your browser.
          </p>
          <p>
            You can also purchase Wreckfinder premium after you have logged in with your email address.
          </p>
          <p className="lead">
            <Link to="/join" className="btn btn-lg btn-secondary">Join Now</Link>
            &nbsp; or &nbsp;
            <Link to="/login" className="btn btn-lg btn-secondary">Login</Link>
          </p>
        </div>
      </LayoutWrapper>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/home.js